import {
  IFlight,
  IFlightFeatures,
  IFlightInput,
  IFlightLeg,
  IFlightInterline,
} from '@cai-services';
import { Quote } from './quote.model';
import { FlightPath } from './flight-path.model';
import { Airport } from './region-airport.model';
import { Route } from './route.model';
import { NegoRoute } from './nego-route.model';
import { Aircraft } from './aircraft.model';
import { FlightRate } from './flight-rate.model';
import { CO2 } from './co2.model';
import { AirlineBrand } from './airline.model';
import { Trip } from './trip.model';

export class FlightInput implements IFlightInput {
  airlineCode: string;
  airlineConditions: string;
  arrivalAirport: string;
  arrivalTime: string;
  available: boolean;
  availableReason: string;
  awbPrefix?: string;
  awbPrefixes?: string[];
  contacts?: string[];
  stops: string;
  departureAirport: string;
  departureTime: string;
  latestAcceptanceTime?: string;
  timeOfAvailability?: string;
  handlingInfoLink?: string;
  ghaName?: string;
  ghaAddress?: string;
  hle?: string;
  features: IFlightFeatures;
  interline?: IFlightInterline;
  flightNumber: string;
  flightUID?: string; // Deprecated
  flightUUID: string;
  legs: Leg[];
  loading: boolean;
  salesConditions: string;
  sortingFlightKey: string;
  source: string;
  airlineCompany?: AirlineBrand;
  freightRate: FreightRate;
  elapsedTime: string;
  rates: FlightRate[];
  checked?: boolean;
  disabled?: boolean;
  selectedRate?: FlightRate;
  qualityRating?: number;
  sortOption?: string;
  co2Efficiency?: number;
  militaryOrDualUseGoods?: boolean;
  checkoutUrl?: string;
  searchResultsOrder?: number;
}

export class Leg implements IFlightLeg {
  flightNumber: string;
  arrivalTime: string;
  arrivalAirport: string;
  departureTime: string;
  departureAirport: string;
  bodyType: string;
  legId: string;
  aircraftCode: string;
  description: string;
  parentFlightUID?: string; // Deprecated
  parentFlightUUID: string;
  aircraft?: Aircraft;
  co2: CO2;
  volumeCapacity?: number;
  weightCapacity?: number;
}

export class InternalRate {
  rate: number;
  fuelSurcharge: number;
  securitySurcharge: number;
  latestAcceptanceTime?: string;
  timeOfAvailability?: string;
}
export class FreightRate {
  rate: number;
  charge: number;
  currency: string;
  otherCharges: number;
  grandTotal: number;
  otherChargeDetail?: OtherChargeDetail[];
}

export interface OtherChargeDetail {
  chargeHead: string;
  chargeDescription: string;
  charge: number;
  dueAgent: boolean;
  dueCarrier: boolean;
}

export class Flight implements IFlight {
  id: number;
  arrivalDate: Date | string;
  departureDate: Date | string;
  flightNo: string;
  weightCapacity: number;
  volumeCapacity: number;
  usedWeight: number;
  usedVolume: number;
  co2: number;
  airlineCompany?: AirlineBrand;
  trips: Trip[];
  aircraft: Aircraft;
  airlineBrand: AirlineBrand;
  isIncomplete: boolean;
  manageable: boolean;
  disabled: boolean;
  estimatedCapacity: number;
  originRegionAirport: Airport;
  destRegionAirport: Airport;
  quotes: Array<Quote>;
  flightId: number;
  endArrivalDate: string;
  startDepartureDate: string;
  flightPaths: Array<FlightPath>;
  route: Route;
  negoRoute: NegoRoute;
  startLegId: string;
  delayTime?: number;
  estimatedRate?: number;
  responsiveness?: number;
  qualityRating?: number;
  isDummy?: boolean = false;
  rank?: number;

  constructor(
    endArrivalDate?: string,
    flightNo?: string,
    startDepartureDate?: string,
    estimatedCapacity?: number,
    startLegId?: string,
  ) {
    this.endArrivalDate = endArrivalDate;
    this.flightNo = flightNo;
    this.startDepartureDate = startDepartureDate;
    this.estimatedCapacity = estimatedCapacity;
    this.startLegId = startLegId;
  }
}

export interface CustomFlightDetails extends FlightInput {
  rateSortOrder?: Array<string>;
}
